import { forcastOverview } from '../../../demoData/dashboardChartContent.json';
import mutations from './mutations';
import Cookies from 'js-cookie';
import axios from 'axios';

const state = () => ({
  forcastData: null,
  foLoading: false,
  dashboardOverviewData: { member: 0, order: 0, message: 0, review: 0 },
  error: null,
});

const actions = {
  async getForceData({ commit }, data) {
    commit('forcastOverviewBegin');
    const config = {
      headers: { Authorization: 'Bearer ' + Cookies.get('token') },
    };
    axios
      .post(process.env.VUE_APP_API_ENDPOINT + '/api/statistics/' + data.type + '/summary/' + data.date, {}, config)
      .then(response => {
        if (response.data.status === true) {
          switch (data.type) {
            case 'member':
              commit('dashboardOverviewDataMemberSuccess', response.data.data.total_record);
              break;
            case 'message':
              commit('dashboardOverviewDataMessageSuccess', response.data.data.total_record);
              break;
            case 'review':
              commit('dashboardOverviewDataReviewSuccess', response.data.data.total_record);
              break;
            case 'order':
              commit('dashboardOverviewDataOrderSuccess', response.data.data.total_amount);
              break;
          }
        } else {
          commit('forcastOverviewErr', response.data.message);
        }
      })
      .catch(e => {
        commit('forcastOverviewErr', e);
      });
  },

  async forcastOverviewGetData({ commit }) {
    const { today } = forcastOverview;
    try {
      commit('forcastOverviewBegin');
      commit('forcastOverviewSuccess', today);
    } catch (err) {
      commit('forcastOverviewErr', err);
    }
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
};
